import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import type { PlaywrightCatalogSpec } from "./playwright-api";

interface TestSelectProps {
  specs: PlaywrightCatalogSpec[];
  ready: boolean;
  value: string[];
  onChange: (value: string[]) => void;
  loading?: boolean;
}

const TestSelect = ({
  specs,
  ready,
  value,
  onChange,
  loading = false,
}: TestSelectProps) => {
  const allSelected = specs.length > 0 && value.length === specs.length;
  const summary = !ready
    ? "All tests"
    : allSelected
      ? `All tests (${specs.length})`
      : `${value.length} of ${specs.length} selected`;

  return (
    <FormControl size="small" disabled={!ready || loading} fullWidth>
      <InputLabel id="playwright-tests-label">Tests</InputLabel>
      <Select
        labelId="playwright-tests-label"
        label="Tests"
        multiple
        value={value}
        renderValue={() => summary}
        onChange={(event) => onChange(event.target.value as string[])}
      >
        <MenuItem
          onClick={(event) => {
            event.preventDefault();
            onChange(allSelected ? [] : specs.map((spec) => spec.id));
          }}
        >
          <ListItemText primary={allSelected ? "Clear" : "Select all"} />
        </MenuItem>
        {specs.map((spec) => (
          <MenuItem key={spec.id} value={spec.id}>
            <Checkbox checked={value.includes(spec.id)} />
            <ListItemText primary={spec.title || spec.id} secondary={spec.file} />
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        {!ready
          ? "The test catalog is not ready; this run will run all tests."
          : "Choose which spec files to run."}
      </FormHelperText>
    </FormControl>
  );
};

export default TestSelect;
